<app-bread-crumb [items]="[{text:  'categories',link:'/admin/settings/category'},{text:pageTitle}]"
    [sectionTitle]="pageTitle"></app-bread-crumb>

<section class="content">

    <!-- inicio do formulário -->
    <form [formGroup]="objectForm" novalidate (ngSubmit)="submitForm()">

        <!-- inicio do box -->
        <ng-box [boxIcon]="'fa fa-list'" [boxTitle]="'Dados da Categoria'" [showBoxFooter]="true">

            <!-- cabesalho do box -->
            <ng-container class="ng-box-header">
                <ng-button (click)="back()" [button]="{name:'back',faIconClass:'fa fa-arrow-left',color:'secondary'}">
                </ng-button>
            </ng-container>

            <!-- inicio do conteudo do box -->
            <ng-container class="ng-box-content">

                <div class="row">
                    <div class="col-md-12">
          
                      <div class="form-group">
          
                        <app-input label="Nome(*)" errorMessage="Campo obrigatório">
                          <input type="text" formControlName="name" class="form-control">
                        </app-input>
          
                      </div>
          
                    </div>
           
                  </div>

            </ng-container>

            <!-- fim do conteudo do box -->

            <!-- inicio do rodapé -->
            <ng-container class="ng-box-footer">
                <div class="row">
                    <div class="col-xs-12">
                        <ng-button class="pull-right" [button]="{
                            name:'salvar',
                            color:'danger',
                            faIconClass:'fa fa-save',
                            type:'submit',
                            loadingText:'SALVANDO',
                            isLoading:isButtonLoading,
                            isDisabled:isButtonLoading || objectForm.invalid}">
                        </ng-button>
                    </div>
                </div>
            </ng-container>
            <!-- fim do rodapé -->

        </ng-box>
        <!-- fim do box -->
    </form>
    <!-- fim do formulário -->
</section>